var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4141,
    cy: 26.5156,
    r: 22.5,
    fill: "#E9EBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9517 20.4688C48.9888 21.5059 49.5938 22.8887 49.5938 24.3579V51.0635C49.5938 54.1748 47.0874 56.5947 44.0625 56.5947H21.9375C18.8262 56.5947 16.4062 54.1748 16.4062 51.0635V17.876C16.4062 14.8511 18.8262 12.3447 21.9375 12.3447H37.5806C39.0498 12.3447 40.4326 12.9497 41.4697 13.9868L47.9517 20.4688ZM45.4453 51.0635H45.3589V26.1729H38.5312C36.9756 26.1729 35.7656 24.9629 35.7656 23.4072V16.5796H21.9375C21.1597 16.5796 20.5547 17.1846 20.5547 17.9624V51.0635C20.5547 51.8413 21.1597 52.4463 21.9375 52.4463H44.0625C44.7539 52.4463 45.4453 51.8413 45.4453 51.0635ZM24.7031 36.5439C24.7031 35.4204 25.5674 34.4697 26.7773 34.4697H39.2227C40.3462 34.4697 41.2969 35.4204 41.2969 36.5439C41.2969 37.7539 40.3462 38.6182 39.2227 38.6182H26.7773C25.5674 38.6182 24.7031 37.7539 24.7031 36.5439ZM39.2227 42.7666C40.3462 42.7666 41.2969 43.7173 41.2969 44.8408C41.2969 46.0508 40.3462 46.915 39.2227 46.915H26.7773C25.5674 46.915 24.7031 46.0508 24.7031 44.8408C24.7031 43.7173 25.5674 42.7666 26.7773 42.7666H39.2227Z",
    fill: "#0C41C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp);
export default __webpack_public_path__ + "static/media/cp.c18894d44475313f0f8562699cf29cc4.svg";
export { ForwardRef as ReactComponent };